import { objectsApi } from '../../API/API';
import {
  SET_CURRENT_PAGE,
  SET_NAV_PARAMS_OBJECTS,
  SET_OBJECTS_LIST,
  UPDATE_OBJECTS_LIST,
} from './constans';

export const setObjectsList = (payload) => {
  return {
    type: SET_OBJECTS_LIST,
    payload,
  };
};

export const UpdateObjectsList = (payload) => {
  return {
    type: UPDATE_OBJECTS_LIST,
    payload,
  };
};

export const setNavParams = (payload) => {
  return {
    type: SET_NAV_PARAMS_OBJECTS,
    payload,
  };
};
export const setCurrentPage = (currentPage) => {
  return {
    type: SET_CURRENT_PAGE,
    currentPage,
  };
};

export const getObjectsList = () => async (dispatch) => {
  let response = await objectsApi.getObjectsList();
  if (response.status) {
    return dispatch(setObjectsList(response.data));
  }
};

export const searchObjects = (search, page) => async (dispatch) => {
  let objects = await objectsApi.searchObjects({ search: search, page: page });
  let navParams = await objectsApi.getNavParams({ search: search });

  if (objects.status) {
    dispatch(setObjectsList(objects.data));
  }
  if (navParams.status) {
    dispatch(setNavParams(navParams.data));
  }
};

export const clearSearch = () => (dispatch) => {
  dispatch(setNavParams(null));
  dispatch(setCurrentPage(1));
  dispatch(setObjectsList(null));
};

export const setNewCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCurrentPage(currentPage));
};
